export const TAB_NAMES = {
    OVERVIEW: 'overview',
    CONNECT: 'connect',
    PRODUCT: 'product',
    TEMPLATES: 'templates',
    INVOICE_TEMPLATES: 'invoice_templates',
    CONTRACT_TEMPLATES: 'contract_templates',
    SETTINGS: 'settings',
    IMPORT: 'import',
    TOOLS: 'tools',
    TAXES: 'taxes',
    EMAIL_ADDRESSES: 'email_addresses',
    SIGNATURES: 'signatures',
    MENU_LINKS: 'menu_links'
}